import Vue from "vue";

import sinisterTransformer from "./../../transformers/sinister/road";
import moment from "moment";

function urlParamsTransformer(options) {
  const from = options.from ? moment(options.from).format("YYYY/MM/DD") : null;
  const to = options.to ? moment(options.to).format("YYYY/MM/DD") : null;
  const search_text = !!options.searchQuery ? options.searchQuery : undefined;
  const filterAddDate = options.filterAddDate;
  return {
    page: options.page,
    size: options.pageSize,
    highway:
      options.highway && options.highway.length
        ? options.highway.join(",")
        : undefined,
    job_type: options.job,
    text: search_text,
    revi: options.revi || undefined,
    process:
      options.process && !options.processSince ? options.process : undefined,
    before: options.processSince ? options.process : undefined,
    from,
    to,
    filter_add_date: filterAddDate || undefined,
  };
}

export default (options) => {
  let id, urlParams;
  let url = `sinisters/roads/`;

  if (typeof options === "object") {
    id = options.id;
    if (options.isCustomer) {
      url = `sinisters/roads/customer/`;
    }

    if (!id) {
      urlParams = urlParamsTransformer(options);
    }
  } else {
    id = options;
  }

  if (id) {
    url += `${id}/`;
  }

  let config;

  if (urlParams) {
    config = {
      params: urlParams,
    };
  }

  return Vue.$http.get(url, config).then((response) => {
    if (!id) {
      const paginationInfo = { ...response.data, results: null };
      const results = response.data.results;

      const sinisters = sinisterTransformer.fetchCollection(results);
      return { sinisters, paginationInfo };
    } else {
      return sinisterTransformer.fetch(response.data, options.isCustomer);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/sinister/fetch.js